///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/select2.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReviewReport/RatingReportTeam.html'
})

export class RatingReportTeamComponent implements OnInit {
    constants: Constants;
    userDetail: any;
    selfuser: boolean = true;
    public showLoader = false;
    public reportItems: any[] = [];
    filter: any = {};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter = { 'Year': moment().format('YYYY')};
    }

    ngOnInit() {
        this.GetRatingReport();
    }


    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }

    public changeYear(event){
        this.filter.Year = event.srcElement.value;
    }


    public clearFilter() {
        this.filter = { 'Year': moment().format('YYYY')};
    }

    public GetRatingReport() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetRatingReport', {"UserId":null, "ReviewerId": this.userDetail.SiteUserId, "Year": this.filter.Year }).subscribe(
            data => {
                this.reportItems = data["RatingReport"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public ShowDetailReport()
    {
        this._route.navigateByUrl("/detailedRatingReport");
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewReport/ratingReportTeam.component.ts
 **/